import { render, staticRenderFns } from "./ClasseVirtuelle.vue?vue&type=template&id=87d158da&scoped=true&"
import script from "./ClasseVirtuelle.vue?vue&type=script&lang=js&"
export * from "./ClasseVirtuelle.vue?vue&type=script&lang=js&"
import style0 from "./ClasseVirtuelle.vue?vue&type=style&index=0&id=87d158da&lang=scss&scoped=true&"
import style1 from "./ClasseVirtuelle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d158da",
  null
  
)

export default component.exports